module.exports = __webpack_public_path__ + "media/SessionStartSoundIAmAnAgent.337a359b.mp3";